// extracted by mini-css-extract-plugin
module.exports = {"label":"Label_label__EDWeJ","arrow":"Label_arrow__h2Bjp","buttonWrapper":"Label_buttonWrapper__2WolO"};